import React from 'react';

import emptyIcon from '../../assets/icons/dashboardEmptyIcon.svg';

interface EmptyStateProps {
  text: string;
  iconClassName?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  text,
  iconClassName = 'h-24 w-24',
}) => (
  <div className="flex flex-col items-center justify-center gap-2 py-8 text-center font-['Plus_Jakarta_Sans',sans-serif]">
    <img src={emptyIcon} alt="" className={iconClassName} />
    <p className="text-sm leading-5 text-gray-500">{text}</p>
  </div>
);
